import CRUDService from 'src/services/CRUDService';

export interface SponsoredRecommendation {
  campaignId: number;
  collegeId: string;
}

export default new CRUDService<SponsoredRecommendation>({
  baseUrl: '/v1/sponsored-recommendations',
  useJWT: true,
});
